import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-6 md:px-10 max-w-7xl">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">
            Trusted by Buyers
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
          Real Reviews From
          <br />
          Spreadsheet Users
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl">
          See how our OOPBuy guides help buyers source smarter and make better purchasing decisions every day.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-5 md:p-6 border border-background-200 ${
                idx >= 5 ? "opacity-50" : ""
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-secondary-500 text-sm"></i>
                ))}
              </div>
              <h4 className="text-sm font-bold font-heading text-foreground-900">
                {t.title}
              </h4>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-5">
                {t.content}
              </p>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}